import React, {useEffect, useState} from "react";
import {getUsersOrdersLists, postOrdersCancel,} from "../../service";
import FixedTabs from "../../components/fixed-tabs";
import usePagination from "../../routers/usePagination";
import {Orders} from "../types";
import useUserInfo from "../../routers/useUserInfo";
import Pagination from "../../components/pagination";
import {dateFormat, priceConvert} from "../../units";
import {useLoading} from "../../components/loading/LoadingProvider";
import {useHistory} from "react-router-dom";
const classnames = require('classnames')

let tabs = ['待支付','已完成','已失效'];

function UserOrder() {

    const [lists,setLists] = useState<Array<Orders>>([])
    const [active,setActive] = useState<number>(0)
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore,reset } = usePagination();
    const userData = useUserInfo()
    const loading = useLoading()
    const { push } = useHistory()

    useEffect(() =>{
        if(userData){
            getUsersOrdersLists({
                userId:userData.id,
                pageNum,
                status:active
            }).then(res => {
                if(res.code === 1){
                    const lists = res.data.list
                    if((lists as Array<Orders>).length > 0){
                        setLists(list => list.concat(lists))
                    }else{
                        noMore()
                    }
                }else{
                    noMore()
                }
            })
        }
    },[active,pageNum])

    const TabChange = (index:number) => {
        setActive(index)
        setLists([])
        setPage(1)
        reset()
    }

    const handleCancel = (id:string) => {
        if(id){
            postOrdersCancel({
                orderId:id,
                userId:userData?.id
            }).then(res => {
                if(res.code === 1){
                    loading.showSuccess('操作成功')
                    TabChange(active)
                }else{
                    loading.showSuccess(res.msg)
                }
            })
        }
    }

    return <div className="orders" style={{ backgroundColor:'#f3f3f3' }}>

        <FixedTabs tabs={ tabs } onChange={ TabChange }/>

        <div className="lists">

            {
                lists.map((item,index) => {
                    return <div className={classnames("item",{ "not-pay": active === 0 },{ "success": active === 1 },{ "fail": active === 2 })} key={index}>
                        <div className="header">
                            <p>订单编号：{ item.orderNumber }</p>
                            {
                                active === 0 && <p>待付款</p>
                            }
                            {
                                active === 1 && <p>已完成</p>
                            }
                            {
                                active === 2 && <p>已失效</p>
                            }
                        </div>
                        <div className="detail">
                            <div className="img-box" style={{ backgroundImage:`url(${ item.coverUrl })` }}/>
                            <div className="text">
                                <h3>课程-《{ item.courseName }》</h3>
                                <div className="flex">
                                    <p>有效期：1个月</p>
                                    <p>¥{ priceConvert(item.totalFee) }</p>
                                </div>
                            </div>
                        </div>
                        <div className="bottom">
                            <p className="d">{ dateFormat(item.createTime,undefined,undefined,true) }</p>
                            {
                                active === 0 && <div className="r">
                                    <div className="_btn" onClick={() => handleCancel(item.id)}>取消订单</div>
                                    <div className="_btn fill" onClick={() => push(`/user/do-pay/${ item.id }`)}>去支付</div>
                                </div>
                            }
                            {
                                active === 1 && <div className="r">
                                    {
                                        item.invalidCode === 0 &&  <div className="_btn">超时取消</div>
                                    }
                                    {
                                        item.invalidCode === 0 &&  <div className="_btn">客户取消</div>
                                    }
                                    {
                                        item.invalidCode === 0 &&  <div className="_btn">后台取消</div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                })
            }

            {/*<div className="item success">*/}
            {/*    <div className="header">*/}
            {/*        <p>订单号：12321327528282</p>*/}
            {/*        <p>待付款</p>*/}
            {/*    </div>*/}
            {/*    <div className="detail">*/}
            {/*        <div className="img-box"/>*/}
            {/*        <div className="text">*/}
            {/*            <h3>BG认证管家</h3>*/}
            {/*            <div className="flex">*/}
            {/*                <p>1年</p>*/}
            {/*                <p>¥800</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className="bottom">*/}
            {/*        <p className="d">2020.9.20 18:32:31</p>*/}
            {/*        <div className="r">*/}
            {/*            <div className="_btn">删除订单</div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/*<div className="item fail">*/}
            {/*    <div className="header">*/}
            {/*        <p>订单号：12321327528282</p>*/}
            {/*        <p>待付款</p>*/}
            {/*    </div>*/}
            {/*    <div className="detail">*/}
            {/*        <div className="img-box"/>*/}
            {/*        <div className="text">*/}
            {/*            <h3>BG认证管家</h3>*/}
            {/*            <div className="flex">*/}
            {/*                <p>1年</p>*/}
            {/*                <p>¥800</p>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className="bottom">*/}
            {/*        <p className="d">2020.9.20 18:32:31</p>*/}
            {/*        <div className="r">*/}
            {/*            <div className="_btn">删除订单</div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/*<div className="item not-pay">*/}
            {/*    <h3>BG认证管家</h3>*/}
            {/*    <p>下单时间：2020-8-20 19:30:52</p>*/}
            {/*    <p>支付金额：99元</p>*/}
            {/*    <div className="btns">*/}
            {/*        <div className="btn fill">立即支付</div>*/}
            {/*        <div className="btn">取消订单</div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className="item fail">*/}
            {/*    <h3>BG认证管家</h3>*/}
            {/*    <p>下单时间：2020-8-20 19:30:52</p>*/}
            {/*    <p>支付金额：99元</p>*/}
            {/*    <p className="pay">已过期</p>*/}
            {/*</div>*/}
            {/*<div className="item success">*/}
            {/*    <h3>BG认证管家</h3>*/}
            {/*    <p>下单时间：2020-8-20 19:30:52</p>*/}
            {/*    <p>支付时间：2020-8-20 19:30:52</p>*/}
            {/*    <p>支付金额：99元</p>*/}
            {/*</div>*/}
            {/*<div className="item not-pay">*/}
            {/*    <h3>BG认证管家</h3>*/}
            {/*    <p>下单时间：2020-8-20 19:30:52</p>*/}
            {/*    <p>支付金额：99元</p>*/}
            {/*    <div className="btns">*/}
            {/*        <div className="btn fill">立即支付</div>*/}
            {/*        <div className="btn">取消订单</div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className="item fail">*/}
            {/*    <h3>BG认证管家</h3>*/}
            {/*    <p>下单时间：2020-8-20 19:30:52</p>*/}
            {/*    <p>支付金额：99元</p>*/}
            {/*    <p className="pay">已过期</p>*/}
            {/*</div>*/}
        </div>

        <Pagination ref={pageRef} length={lists.length} onChange={ (n) => setPage(n) }/>
    </div>
}

export default UserOrder;
